export default {
  SET_SUBSCRIPTION_TIERS(state, tiers) {
    state.subscriptionTiers = tiers;
  },
  SET_SUBSCRIPTION_TIER(state, tier) {
    state.subscriptionTier = tier;
  },
  ADD_SUBSCRIPTION_TIER(state, tier) {
    state.subscriptionTiers.push(tier);
  },
  UPDATE_SUBSCRIPTION_TIER(state, updatedTier) {
    const index = state.subscriptionTiers.findIndex(tier => tier._id === updatedTier._id);
    if (index !== -1) {
      state.subscriptionTiers.splice(index, 1, updatedTier);
    }
  },
  REMOVE_SUBSCRIPTION_TIER(state, tierId) {
    state.subscriptionTiers = state.subscriptionTiers.filter(tier => tier._id !== tierId);
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

